import { Component, Input, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import { CloudServiceEnum } from 'src/app/services/cloud-storage/enums/cloud-service.enum';
import { CloudDlgManagerService } from 'src/app/services/cloud-storage/cloud-dlg-manager.service';
import { Breadcrumb } from 'src/app/utils/interfaces/breadcrumb.interface';
import { Observable, Subscription } from 'rxjs';
import { NgStyle, AsyncPipe } from '@angular/common';

@Component({
    selector: 'asg-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: true,
    imports: [NgStyle, AsyncPipe]
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  @Input() currentCloud: CloudServiceEnum;
  @Output() rootBreadcrumbClicked: EventEmitter<void> = new EventEmitter();
  @Output() breadcrumbClicked: EventEmitter<void> = new EventEmitter();

  private readonly subscriptions: Subscription = new Subscription();
  private breadcrumbs: Breadcrumb[] = [];

  menuOffset: number = 0;
  showBreadcrumbsMenu: boolean = false;

  get topBreadcrumbs(): Breadcrumb[] { return this.breadcrumbs.filter((_item, idx, arr) => idx >= arr.length - 2) };
  get menuBreadcrumbs(): Breadcrumb[] { return this.breadcrumbs.filter((_item, idx, arr) => idx < arr.length - 2) };
  get loadingHistory(): Observable<boolean> { return this.cloudManager.loadingHistory; }

  constructor(private readonly cloudManager: CloudDlgManagerService) { }

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  rootBreadcrumbOnClicked(): void {
    this.showBreadcrumbsMenu = false;
    this.rootBreadcrumbClicked.emit();
  }

  breadcrumbOnClicked(url: string): void {
      this.showBreadcrumbsMenu = false;
      this.cloudManager.shiftFolderHistory(url);
      this.breadcrumbClicked.emit();
  }

  private init(): void {
    this.subscriptions.add(
      this.cloudManager.foldersHistoryObservable.subscribe(folders => {
        if (folders.length === 0) {
          this.breadcrumbs = [];
        } else {
          this.breadcrumbs = folders.map(x => ({ url: x.id, label: x.name }));
        }
      })
    );
  }
}
